module.exports = __webpack_public_path__ + "6c6890dc5803e3c90401ff48a0311dd5.png";